<template>
  <div class="contacts">
    <CloseModalBtn :closeModal="closeModal" />
    <h5>
      {{
        localStorage.translations.pages['setting-personal_area']['dialog-new_address']['title_add']
      }}
    </h5>
    <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="addAddress">
      <div class="container_form invite">
        <label>{{ localStorage.translations.pages['setting-personal_area'].labels['name'] }}</label>
        <v-text-field
          outlined
          height="48px"
          v-model="name"
          :rules="[inputRules.required]"
        ></v-text-field>
        <label>{{
          localStorage.translations.pages['setting-personal_area'].labels['ulitsa']
        }}</label>
        <v-text-field
          outlined
          height="48px"
          v-model="street"
          :rules="[inputRules.required]"
        ></v-text-field>
        <label>{{
          localStorage.translations.pages['setting-personal_area'].labels['gorod']
        }}</label>
        <v-text-field
          outlined
          height="48px"
          v-model="city"
          :rules="[inputRules.required]"
        ></v-text-field>
        <label>{{
          localStorage.translations.pages['setting-personal_area'].labels['indeks']
        }}</label>
        <v-text-field
          outlined
          height="48px"
          v-model="zip"
          :rules="[inputRules.required]"
        ></v-text-field>
        <div class="container_btn">
          <v-btn height="48px" width="100%" class="send_email" text type="submit">{{
            localStorage.translations.pages.common.buttons['sohranit']
          }}</v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import CloseModalBtn from 'components/CloseModalBtn'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactAdressAddModalBody',
  components: { CloseModalBtn },
  props: ['closeModal', 'page', 'limit'],
  data() {
    return {
      valid: false,
      name: '',
      city: '',
      street: '',
      zip: '',
    }
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    validate() {
      this.$refs.form.validate()
    },
    async addAddress() {
      await this.validate()
      if (this.valid) {
        this.$emit('addAddress', {
          name: this.name,
          city: this.city,
          street: this.street,
          zip: this.zip,
        })
        this.closeModal()
      }
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
  },
}
</script>

<style lang="scss" scoped>
.contacts {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  position: relative;
  padding: 40px 50px;
  h5 {
    font-weight: 500;
    font-size: 36px;
    line-height: 42px;
    text-align: center;
    margin-bottom: 50px;
  }
  .container_btn {
    text-align: center;
    padding-top: 15px;
    .v-input__append-inner i {
      color: black !important;
    }
    .v-btn {
      border-radius: 28px;
    }
  }
}
.v-text-field {
  input {
    padding: 12px 0px 12px 16px !important;
  }
}

.container_form {
  text-align: left;

  label {
    font-weight: normal;
    font-size: 14px;
    line-height: 26px;
    color: #52525f;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
    fieldset {
      border: 1px solid #b4b4b4;
      border-radius: 4px;
    }
    .theme--light.v-icon {
      color: #b4b4b4;
    }
  }
  .save_contact {
    width: 170px;
    background: #277faf;
    border-radius: 8px;
    color: white !important;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    &:hover {
      background-color: #16558f;
    }
  }
  .send_email {
    width: 100%;
    background: #277faf;
    box-shadow: 0px 8px 16px rgba(67, 142, 184, 0.2);
    border-radius: 28px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.04em;
    color: #ffffff !important;
    &:hover {
      background-color: #16558f;
    }
  }
}
</style>
